import * as Yup from 'yup';
import { BaseForm } from '../../../../shared/domain/forms/BaseForm';

export class CreateEditOccurrenceContextInfoForm extends BaseForm<CreateEditOccurrenceContextInfoForm> {
  mainReasonId: string = '';
  complementaryReasons: string[] = [];
  clippings: string[] = [];
  massacre: boolean | undefined = undefined;
  policeUnit: string = '';
  relatedNews: string = '';
  observations: string = '';

  validationSchema = ({
    isRelatedNewsRequired = false,
    isActionPoliceReasonSelected = false,
    isObservationsRequired = false
  }: {
    isRelatedNewsRequired?: boolean;
    isActionPoliceReasonSelected?: boolean;
    isObservationsRequired?: boolean;
  }) =>
    Yup.object().shape({
      mainReasonId: Yup.string()
        .nullable()
        .required(this.requiredDefaultMsg('motivo principal')),
      massacre: Yup.boolean()
        .nullable()
        .required(this.requiredDefaultMsg('chacina')),
      policeUnit: Yup.string().when({
        is: () => isActionPoliceReasonSelected,
        then: Yup.string()
          .nullable()
          .required(this.requiredDefaultMsg('unidades policiais presentes')),
        otherwise: Yup.string().nullable()
      }),
      relatedNews: this.yupValidationForRelatedNews(
        isRelatedNewsRequired,
        'links de notícias relacionadas'
      ),
      observations: this.yupValidationForRelatedNews(
        isObservationsRequired,
        'observação'
      )
    });

  constructor(data?: Partial<CreateEditOccurrenceContextInfoForm>) {
    super();
    Object.assign(this, data);
  }

  yupValidationForRelatedNews(
    isRelatedNewsRequired: boolean,
    fieldMsg: string
  ) {
    return Yup.string().when({
      is: () => isRelatedNewsRequired,
      then: Yup.string().nullable().required(this.requiredDefaultMsg(fieldMsg)),
      otherwise: Yup.string().nullable()
    });
  }
}
